import {Auth, getAuth} from "@firebase/auth";
import {Member, Members, User} from "./entities";
import {BaseApp, getGuestMemberId, setGuestMemberId} from "./BaseApp";
import {md5_uuid} from "./md5";
import {_Accounts, Account} from "./types";

export class MemberAuth {

  private accounts: Account[] = [];

  constructor(readonly member: Member, readonly auth: Auth) {
  }

  getMemberId(): string {
    return this.member?.memberId;
  }

  async getOrLoadAccounts(): Promise<Account[]> {
    if (!(this.accounts?.length > 0)) {
      this.accounts = await _Accounts.getInstance().getOrLoadListItems();
    }
    return this.accounts;
  }

  getAccountByType(type: string): Account | null | undefined {
    return this.accounts?.find(account => account.type === type);
  }

  async getOrLoadAccountByType(type: string, create?: boolean): Promise<Account | null | undefined> {
    const accounts = await this.getOrLoadAccounts();
    let account = accounts?.find(account => account.type === type);
    if (!account && create) {
      account = Account.createNew(type, this.member);
      await _Accounts.getInstance().addListItem(account);
      this.accounts = [...(this.accounts || []), account];
    }
    return account;
  }
}

let MEMBER_AUTH: MemberAuth;

export async function initMemberAuth(): Promise<MemberAuth> {
  if (!MEMBER_AUTH) {
    const auth = getAuth();
    const member = auth.currentUser && await Members.getInstance().getOrLoadMemberByUid(auth.currentUser.uid, true, BaseApp.CONTEXT.getAppConfig()?.loginConfig?.provisioning?.usernameEnabled);
    if (member) {
      MEMBER_AUTH = new MemberAuth(member, auth);
    }
  }
  return MEMBER_AUTH;
}

export function getMemberAuth(): MemberAuth | null {
  const auth = MEMBER_AUTH;
  if (auth) {
    return auth;
  }
  if (BaseApp.CONTEXT.getAppConfig()?.loginConfig.guestLogin) {
    return getGuestMemberAuth();
  }
  return null;
}

export function createGuestMemberAuth(guestMemberId: string) {
  if (!MEMBER_AUTH) {
    const member = new Member(guestMemberId, null);
    member.user = new User(null, "Guest User", null, null, null, null, null, false, false, true);
    MEMBER_AUTH = new MemberAuth(member, null);
  }
  return MEMBER_AUTH;
}

function getGuestMemberAuth(): MemberAuth {
  let guestMemberId = getGuestMemberId();
  if (!guestMemberId) {
    guestMemberId = md5_uuid();
    setGuestMemberId(guestMemberId);
  }
  return createGuestMemberAuth(guestMemberId);
}
